export const borderRadiusVariables = {
  'radius-none': '0px',
  'radius-xxxs': '4px',
  'radius-xxs': '8px',
  'radius-xs': '12px',
  'radius-sm': '16px',
  'radius-md': '24px',
  'radius-lg': '32px',
  'radius-xl': '40px',
  'radius-xxl': '48px',
  'radius-xxxl': '64px',
  'radius-round': '1000px',
};
